import { render, staticRenderFns } from "./ProductH5Detail.vue?vue&type=template&id=4412b9cd&"
import script from "./ProductH5Detail.vue?vue&type=script&lang=js&"
export * from "./ProductH5Detail.vue?vue&type=script&lang=js&"
import style0 from "./ProductH5Detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports